<template>
	<router-view />
</template>

<script>
	export default {
		data() {
			return {}
		},

		created() {
			// this.yonghu = this.$qu('yonghu');
			// if (!this.yonghu) {
			// 	this.yonghu = {kouling:''};
			// }			
			this.$quanju('$shanghu',this.$qu('shanghu'))
			this.$biaoti('左福右利2.0核销系统（浪卡卡）');
		},

	}
</script>

<style>
	html,
	body {
		padding: 0;
		margin: 0;
	}
	
	@import "./plugins/icon.css";
	@import "./plugins/icon_1.css";
	@import "./plugins/zhiwi.css";

	.el-tabs__nav {
		margin-left: 0;
	}
	.el-input__inner{border:auto !important;}
	.el-form-item__content{
		margin-left: auto;
	}
</style>
